/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AgentConfigUpdate } from '../models/agentConfigUpdate';

import type { BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost } from '../models/bodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost';

import type { BulkDeleteRequest } from '../models/bulkDeleteRequest';

import type { BulkUpdateRequest } from '../models/bulkUpdateRequest';

import type { BusinessHoursCreate } from '../models/businessHoursCreate';

import type { BusinessHoursResponse } from '../models/businessHoursResponse';

import type { CSATSubmit } from '../models/cSATSubmit';

import type { GetCsatReportApiV1SupportCsatReportsGetParams } from '../models/getCsatReportApiV1SupportCsatReportsGetParams';

import type { GetDashboardApiV1SupportDashboardGetParams } from '../models/getDashboardApiV1SupportDashboardGetParams';

import type { GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams } from '../models/getMessagesApiV1SupportTicketsTicketIdMessagesGetParams';

import type { GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams } from '../models/getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams';

import type { GetTicketStatsApiV1SupportTicketsStatsGetParams } from '../models/getTicketStatsApiV1SupportTicketsStatsGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { KBArticleCreate } from '../models/kBArticleCreate';

import type { KBArticleFeedback } from '../models/kBArticleFeedback';

import type { KBArticleUpdate } from '../models/kBArticleUpdate';

import type { KBCategoryCreate } from '../models/kBCategoryCreate';

import type { KBCategoryUpdate } from '../models/kBCategoryUpdate';

import type { ListAgentsApiV1SupportAgentsGetParams } from '../models/listAgentsApiV1SupportAgentsGetParams';

import type { ListKbArticlesApiV1SupportKbArticlesGetParams } from '../models/listKbArticlesApiV1SupportKbArticlesGetParams';

import type { ListKbCategoriesApiV1SupportKbCategoriesGetParams } from '../models/listKbCategoriesApiV1SupportKbCategoriesGetParams';

import type { ListRoutingRulesApiV1SupportRoutingRulesGetParams } from '../models/listRoutingRulesApiV1SupportRoutingRulesGetParams';

import type { ListSlaPoliciesApiV1SupportSlaPoliciesGetParams } from '../models/listSlaPoliciesApiV1SupportSlaPoliciesGetParams';

import type { ListTicketsApiV1SupportTicketsGetParams } from '../models/listTicketsApiV1SupportTicketsGetParams';

import type { MessageCreate } from '../models/messageCreate';

import type { ReorderRulesRequest } from '../models/reorderRulesRequest';

import type { RoutingRuleCreate } from '../models/routingRuleCreate';

import type { RoutingRuleUpdate } from '../models/routingRuleUpdate';

import type { SLAPolicyCreate } from '../models/sLAPolicyCreate';

import type { SLAPolicyResponse } from '../models/sLAPolicyResponse';

import type { SLAPolicyUpdate } from '../models/sLAPolicyUpdate';

import type { SupportDashboard } from '../models/supportDashboard';

import type { TaskLinkedTicketListResponse } from '../models/taskLinkedTicketListResponse';

import type { TicketCreate } from '../models/ticketCreate';

import type { TicketFilterFacets } from '../models/ticketFilterFacets';

import type { TicketLinkedFileListResponse } from '../models/ticketLinkedFileListResponse';

import type { TicketLinkedTaskListResponse } from '../models/ticketLinkedTaskListResponse';

import type { TicketLinkedWorkItemResponse } from '../models/ticketLinkedWorkItemResponse';

import type { TicketStatsResponse } from '../models/ticketStatsResponse';

import type { TicketTaskLinkCreate } from '../models/ticketTaskLinkCreate';

import type { TicketUpdate } from '../models/ticketUpdate';

import type { TicketWorkItemLinkCreate } from '../models/ticketWorkItemLinkCreate';

import type { UpdateUserSettingsApiV1SupportSettingsUserPutBody } from '../models/updateUserSettingsApiV1SupportSettingsUserPutBody';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get dashboard data including ticket stats, KB stats, and recent activity.

See docs/platform/dashboard-kpi-endpoints.md. The scope is resolved here,
outside ``cached_kpi``, so a Full-Access admin's universal read still writes
its ``admin_override_read`` audit row on a cache hit.
 * @summary Get Dashboard
 */
export const getDashboardApiV1SupportDashboardGet = (
  params?: GetDashboardApiV1SupportDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SupportDashboard>({
    url: `/api/v1/support/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDashboardApiV1SupportDashboardGetQueryKey = (
  params?: GetDashboardApiV1SupportDashboardGetParams
) => {
  return [`/api/v1/support/dashboard`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardApiV1SupportDashboardGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SupportDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDashboardApiV1SupportDashboardGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>
  > = ({ signal }) => getDashboardApiV1SupportDashboardGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardApiV1SupportDashboardGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>
>;
export type GetDashboardApiV1SupportDashboardGetQueryError =
  HTTPValidationError;

export function useGetDashboardApiV1SupportDashboardGet<
  TData = Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetDashboardApiV1SupportDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
          TError,
          Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDashboardApiV1SupportDashboardGet<
  TData = Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SupportDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
          TError,
          Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardApiV1SupportDashboardGet<
  TData = Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SupportDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dashboard
 */

export function useGetDashboardApiV1SupportDashboardGet<
  TData = Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SupportDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardApiV1SupportDashboardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDashboardApiV1SupportDashboardGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Detailed CSAT report: headline metrics, distribution, trend, and breakdowns.
 * @summary Get Csat Report
 */
export const getCsatReportApiV1SupportCsatReportsGet = (
  params?: GetCsatReportApiV1SupportCsatReportsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/csat-reports`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetCsatReportApiV1SupportCsatReportsGetQueryKey = (
  params?: GetCsatReportApiV1SupportCsatReportsGetParams
) => {
  return [`/api/v1/support/csat-reports`, ...(params ? [params] : [])] as const;
};

export const getGetCsatReportApiV1SupportCsatReportsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
  TError = HTTPValidationError
>(
  params?: GetCsatReportApiV1SupportCsatReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCsatReportApiV1SupportCsatReportsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>
  > = ({ signal }) => getCsatReportApiV1SupportCsatReportsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCsatReportApiV1SupportCsatReportsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>
>;
export type GetCsatReportApiV1SupportCsatReportsGetQueryError =
  HTTPValidationError;

export function useGetCsatReportApiV1SupportCsatReportsGet<
  TData = Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetCsatReportApiV1SupportCsatReportsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
          TError,
          Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCsatReportApiV1SupportCsatReportsGet<
  TData = Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
  TError = HTTPValidationError
>(
  params?: GetCsatReportApiV1SupportCsatReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
          TError,
          Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCsatReportApiV1SupportCsatReportsGet<
  TData = Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
  TError = HTTPValidationError
>(
  params?: GetCsatReportApiV1SupportCsatReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Csat Report
 */

export function useGetCsatReportApiV1SupportCsatReportsGet<
  TData = Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
  TError = HTTPValidationError
>(
  params?: GetCsatReportApiV1SupportCsatReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCsatReportApiV1SupportCsatReportsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCsatReportApiV1SupportCsatReportsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return linked-record candidates from the broad accessible ticket scope.
 * @summary Get Ticket Filter Facets
 */
export const getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet = (
  params?: GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TicketFilterFacets>({
    url: `/api/v1/support/tickets/filter-facets`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetQueryKey =
  (params?: GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams) => {
    return [
      `/api/v1/support/tickets/filter-facets`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
        >
      >
    > = ({ signal }) =>
      getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet>
    >
  >;
export type GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetQueryError =
  HTTPValidationError;

export function useGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ticket Filter Facets
 */

export function useGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketFilterFacetsApiV1SupportTicketsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTicketFilterFacetsApiV1SupportTicketsFilterFacetsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List support tickets.
 * @summary List Tickets
 */
export const listTicketsApiV1SupportTicketsGet = (
  params?: ListTicketsApiV1SupportTicketsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTicketsApiV1SupportTicketsGetQueryKey = (
  params?: ListTicketsApiV1SupportTicketsGetParams
) => {
  return [`/api/v1/support/tickets`, ...(params ? [params] : [])] as const;
};

export const getListTicketsApiV1SupportTicketsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1SupportTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTicketsApiV1SupportTicketsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>
  > = ({ signal }) => listTicketsApiV1SupportTicketsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTicketsApiV1SupportTicketsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>
>;
export type ListTicketsApiV1SupportTicketsGetQueryError = HTTPValidationError;

export function useListTicketsApiV1SupportTicketsGet<
  TData = Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListTicketsApiV1SupportTicketsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
          TError,
          Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTicketsApiV1SupportTicketsGet<
  TData = Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1SupportTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
          TError,
          Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTicketsApiV1SupportTicketsGet<
  TData = Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1SupportTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tickets
 */

export function useListTicketsApiV1SupportTicketsGet<
  TData = Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
  TError = HTTPValidationError
>(
  params?: ListTicketsApiV1SupportTicketsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTicketsApiV1SupportTicketsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTicketsApiV1SupportTicketsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new support ticket.
 * @summary Create Ticket
 */
export const createTicketApiV1SupportTicketsPost = (
  ticketCreate: TicketCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ticketCreate,
    signal
  });
};

export const getCreateTicketApiV1SupportTicketsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTicketApiV1SupportTicketsPost>>,
    TError,
    { data: TicketCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTicketApiV1SupportTicketsPost>>,
  TError,
  { data: TicketCreate },
  TContext
> => {
  const mutationKey = ['createTicketApiV1SupportTicketsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTicketApiV1SupportTicketsPost>>,
    { data: TicketCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createTicketApiV1SupportTicketsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTicketApiV1SupportTicketsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTicketApiV1SupportTicketsPost>>
>;
export type CreateTicketApiV1SupportTicketsPostMutationBody = TicketCreate;
export type CreateTicketApiV1SupportTicketsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Ticket
 */
export const useCreateTicketApiV1SupportTicketsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTicketApiV1SupportTicketsPost>>,
      TError,
      { data: TicketCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTicketApiV1SupportTicketsPost>>,
  TError,
  { data: TicketCreate },
  TContext
> => {
  const mutationOptions =
    getCreateTicketApiV1SupportTicketsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get ticket statistics.

An aggregate, not a list: every field is a scalar or a histogram whose key set
is bounded by the status/priority enums, so there is nothing to page.
 * @summary Get Ticket Stats
 */
export const getTicketStatsApiV1SupportTicketsStatsGet = (
  params?: GetTicketStatsApiV1SupportTicketsStatsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TicketStatsResponse>({
    url: `/api/v1/support/tickets/stats`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTicketStatsApiV1SupportTicketsStatsGetQueryKey = (
  params?: GetTicketStatsApiV1SupportTicketsStatsGetParams
) => {
  return [
    `/api/v1/support/tickets/stats`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetTicketStatsApiV1SupportTicketsStatsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
  TError = HTTPValidationError
>(
  params?: GetTicketStatsApiV1SupportTicketsStatsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTicketStatsApiV1SupportTicketsStatsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>
  > = ({ signal }) => getTicketStatsApiV1SupportTicketsStatsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTicketStatsApiV1SupportTicketsStatsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>
>;
export type GetTicketStatsApiV1SupportTicketsStatsGetQueryError =
  HTTPValidationError;

export function useGetTicketStatsApiV1SupportTicketsStatsGet<
  TData = Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetTicketStatsApiV1SupportTicketsStatsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
          TError,
          Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTicketStatsApiV1SupportTicketsStatsGet<
  TData = Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
  TError = HTTPValidationError
>(
  params?: GetTicketStatsApiV1SupportTicketsStatsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
          TError,
          Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTicketStatsApiV1SupportTicketsStatsGet<
  TData = Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
  TError = HTTPValidationError
>(
  params?: GetTicketStatsApiV1SupportTicketsStatsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ticket Stats
 */

export function useGetTicketStatsApiV1SupportTicketsStatsGet<
  TData = Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
  TError = HTTPValidationError
>(
  params?: GetTicketStatsApiV1SupportTicketsStatsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketStatsApiV1SupportTicketsStatsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTicketStatsApiV1SupportTicketsStatsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a ticket by ID.
 * @summary Get Ticket
 */
export const getTicketApiV1SupportTicketsTicketIdGet = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}`,
    method: 'GET',
    signal
  });
};

export const getGetTicketApiV1SupportTicketsTicketIdGetQueryKey = (
  ticketId?: string
) => {
  return [`/api/v1/support/tickets/${ticketId}`] as const;
};

export const getGetTicketApiV1SupportTicketsTicketIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTicketApiV1SupportTicketsTicketIdGetQueryKey(ticketId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>
  > = ({ signal }) => getTicketApiV1SupportTicketsTicketIdGet(ticketId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!ticketId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTicketApiV1SupportTicketsTicketIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>
>;
export type GetTicketApiV1SupportTicketsTicketIdGetQueryError =
  HTTPValidationError;

export function useGetTicketApiV1SupportTicketsTicketIdGet<
  TData = Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
  TError = HTTPValidationError
>(
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
          TError,
          Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTicketApiV1SupportTicketsTicketIdGet<
  TData = Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
          TError,
          Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTicketApiV1SupportTicketsTicketIdGet<
  TData = Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ticket
 */

export function useGetTicketApiV1SupportTicketsTicketIdGet<
  TData = Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketApiV1SupportTicketsTicketIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTicketApiV1SupportTicketsTicketIdGetQueryOptions(
    ticketId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a ticket.
 * @summary Update Ticket
 */
export const updateTicketApiV1SupportTicketsTicketIdPut = (
  ticketId: string,
  ticketUpdate: TicketUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: ticketUpdate
  });
};

export const getUpdateTicketApiV1SupportTicketsTicketIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTicketApiV1SupportTicketsTicketIdPut>>,
    TError,
    { ticketId: string; data: TicketUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTicketApiV1SupportTicketsTicketIdPut>>,
  TError,
  { ticketId: string; data: TicketUpdate },
  TContext
> => {
  const mutationKey = ['updateTicketApiV1SupportTicketsTicketIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTicketApiV1SupportTicketsTicketIdPut>>,
    { ticketId: string; data: TicketUpdate }
  > = (props) => {
    const { ticketId, data } = props ?? {};

    return updateTicketApiV1SupportTicketsTicketIdPut(ticketId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTicketApiV1SupportTicketsTicketIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTicketApiV1SupportTicketsTicketIdPut>>
  >;
export type UpdateTicketApiV1SupportTicketsTicketIdPutMutationBody =
  TicketUpdate;
export type UpdateTicketApiV1SupportTicketsTicketIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Ticket
 */
export const useUpdateTicketApiV1SupportTicketsTicketIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTicketApiV1SupportTicketsTicketIdPut>>,
      TError,
      { ticketId: string; data: TicketUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTicketApiV1SupportTicketsTicketIdPut>>,
  TError,
  { ticketId: string; data: TicketUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTicketApiV1SupportTicketsTicketIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a ticket and all associated data.
 * @summary Delete Ticket
 */
export const deleteTicketApiV1SupportTicketsTicketIdDelete = (
  ticketId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}`,
    method: 'DELETE'
  });
};

export const getDeleteTicketApiV1SupportTicketsTicketIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTicketApiV1SupportTicketsTicketIdDelete>>,
    TError,
    { ticketId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTicketApiV1SupportTicketsTicketIdDelete>>,
  TError,
  { ticketId: string },
  TContext
> => {
  const mutationKey = ['deleteTicketApiV1SupportTicketsTicketIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTicketApiV1SupportTicketsTicketIdDelete>>,
    { ticketId: string }
  > = (props) => {
    const { ticketId } = props ?? {};

    return deleteTicketApiV1SupportTicketsTicketIdDelete(ticketId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTicketApiV1SupportTicketsTicketIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteTicketApiV1SupportTicketsTicketIdDelete>>
  >;

export type DeleteTicketApiV1SupportTicketsTicketIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Ticket
 */
export const useDeleteTicketApiV1SupportTicketsTicketIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTicketApiV1SupportTicketsTicketIdDelete>>,
      TError,
      { ticketId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTicketApiV1SupportTicketsTicketIdDelete>>,
  TError,
  { ticketId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteTicketApiV1SupportTicketsTicketIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Add a message to a ticket.
 * @summary Add Message
 */
export const addMessageApiV1SupportTicketsTicketIdMessagesPost = (
  ticketId: string,
  messageCreate: MessageCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}/messages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: messageCreate,
    signal
  });
};

export const getAddMessageApiV1SupportTicketsTicketIdMessagesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addMessageApiV1SupportTicketsTicketIdMessagesPost>
      >,
      TError,
      { ticketId: string; data: MessageCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addMessageApiV1SupportTicketsTicketIdMessagesPost>
    >,
    TError,
    { ticketId: string; data: MessageCreate },
    TContext
  > => {
    const mutationKey = ['addMessageApiV1SupportTicketsTicketIdMessagesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addMessageApiV1SupportTicketsTicketIdMessagesPost>
      >,
      { ticketId: string; data: MessageCreate }
    > = (props) => {
      const { ticketId, data } = props ?? {};

      return addMessageApiV1SupportTicketsTicketIdMessagesPost(ticketId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddMessageApiV1SupportTicketsTicketIdMessagesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addMessageApiV1SupportTicketsTicketIdMessagesPost>
    >
  >;
export type AddMessageApiV1SupportTicketsTicketIdMessagesPostMutationBody =
  MessageCreate;
export type AddMessageApiV1SupportTicketsTicketIdMessagesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Message
 */
export const useAddMessageApiV1SupportTicketsTicketIdMessagesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addMessageApiV1SupportTicketsTicketIdMessagesPost>
      >,
      TError,
      { ticketId: string; data: MessageCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addMessageApiV1SupportTicketsTicketIdMessagesPost>>,
  TError,
  { ticketId: string; data: MessageCreate },
  TContext
> => {
  const mutationOptions =
    getAddMessageApiV1SupportTicketsTicketIdMessagesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get messages for a ticket.
 * @summary Get Messages
 */
export const getMessagesApiV1SupportTicketsTicketIdMessagesGet = (
  ticketId: string,
  params?: GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}/messages`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetMessagesApiV1SupportTicketsTicketIdMessagesGetQueryKey = (
  ticketId?: string,
  params?: GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams
) => {
  return [
    `/api/v1/support/tickets/${ticketId}/messages`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetMessagesApiV1SupportTicketsTicketIdMessagesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    params?: GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMessagesApiV1SupportTicketsTicketIdMessagesGetQueryKey(
        ticketId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
      >
    > = ({ signal }) =>
      getMessagesApiV1SupportTicketsTicketIdMessagesGet(
        ticketId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!ticketId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMessagesApiV1SupportTicketsTicketIdMessagesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
    >
  >;
export type GetMessagesApiV1SupportTicketsTicketIdMessagesGetQueryError =
  HTTPValidationError;

export function useGetMessagesApiV1SupportTicketsTicketIdMessagesGet<
  TData = Awaited<
    ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  params: undefined | GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessagesApiV1SupportTicketsTicketIdMessagesGet<
  TData = Awaited<
    ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  params?: GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessagesApiV1SupportTicketsTicketIdMessagesGet<
  TData = Awaited<
    ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  params?: GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Messages
 */

export function useGetMessagesApiV1SupportTicketsTicketIdMessagesGet<
  TData = Awaited<
    ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  params?: GetMessagesApiV1SupportTicketsTicketIdMessagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMessagesApiV1SupportTicketsTicketIdMessagesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMessagesApiV1SupportTicketsTicketIdMessagesGetQueryOptions(
      ticketId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mark a ticket's message thread read for the current agent.

Upserts the agent's last-read watermark so ``unread_count`` drops to zero
on the next ticket fetch. The frontend calls this when the Messages tab is
opened, then invalidates the ticket detail query to clear the badge.
 * @summary Mark Ticket Read
 */
export const markTicketReadApiV1SupportTicketsTicketIdMarkReadPost = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}/mark-read`,
    method: 'POST',
    signal
  });
};

export const getMarkTicketReadApiV1SupportTicketsTicketIdMarkReadPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markTicketReadApiV1SupportTicketsTicketIdMarkReadPost>
      >,
      TError,
      { ticketId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof markTicketReadApiV1SupportTicketsTicketIdMarkReadPost>
    >,
    TError,
    { ticketId: string },
    TContext
  > => {
    const mutationKey = [
      'markTicketReadApiV1SupportTicketsTicketIdMarkReadPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof markTicketReadApiV1SupportTicketsTicketIdMarkReadPost>
      >,
      { ticketId: string }
    > = (props) => {
      const { ticketId } = props ?? {};

      return markTicketReadApiV1SupportTicketsTicketIdMarkReadPost(ticketId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkTicketReadApiV1SupportTicketsTicketIdMarkReadPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof markTicketReadApiV1SupportTicketsTicketIdMarkReadPost>
    >
  >;

export type MarkTicketReadApiV1SupportTicketsTicketIdMarkReadPostMutationError =
  HTTPValidationError;

/**
 * @summary Mark Ticket Read
 */
export const useMarkTicketReadApiV1SupportTicketsTicketIdMarkReadPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markTicketReadApiV1SupportTicketsTicketIdMarkReadPost>
      >,
      TError,
      { ticketId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof markTicketReadApiV1SupportTicketsTicketIdMarkReadPost>
  >,
  TError,
  { ticketId: string },
  TContext
> => {
  const mutationOptions =
    getMarkTicketReadApiV1SupportTicketsTicketIdMarkReadPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit CSAT rating for a ticket.
 * @summary Submit Csat
 */
export const submitCsatApiV1SupportTicketsTicketIdCsatPost = (
  ticketId: string,
  cSATSubmit: CSATSubmit,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}/csat`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cSATSubmit,
    signal
  });
};

export const getSubmitCsatApiV1SupportTicketsTicketIdCsatPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitCsatApiV1SupportTicketsTicketIdCsatPost>>,
    TError,
    { ticketId: string; data: CSATSubmit },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitCsatApiV1SupportTicketsTicketIdCsatPost>>,
  TError,
  { ticketId: string; data: CSATSubmit },
  TContext
> => {
  const mutationKey = ['submitCsatApiV1SupportTicketsTicketIdCsatPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitCsatApiV1SupportTicketsTicketIdCsatPost>>,
    { ticketId: string; data: CSATSubmit }
  > = (props) => {
    const { ticketId, data } = props ?? {};

    return submitCsatApiV1SupportTicketsTicketIdCsatPost(ticketId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitCsatApiV1SupportTicketsTicketIdCsatPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof submitCsatApiV1SupportTicketsTicketIdCsatPost>>
  >;
export type SubmitCsatApiV1SupportTicketsTicketIdCsatPostMutationBody =
  CSATSubmit;
export type SubmitCsatApiV1SupportTicketsTicketIdCsatPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Csat
 */
export const useSubmitCsatApiV1SupportTicketsTicketIdCsatPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitCsatApiV1SupportTicketsTicketIdCsatPost>>,
      TError,
      { ticketId: string; data: CSATSubmit },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitCsatApiV1SupportTicketsTicketIdCsatPost>>,
  TError,
  { ticketId: string; data: CSATSubmit },
  TContext
> => {
  const mutationOptions =
    getSubmitCsatApiV1SupportTicketsTicketIdCsatPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a software factory work item linked to this ticket.
 * @summary Create Work Item From Ticket
 */
export const createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}/work-item`,
    method: 'POST',
    signal
  });
};

export const getCreateWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost
        >
      >,
      TError,
      { ticketId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost
      >
    >,
    TError,
    { ticketId: string },
    TContext
  > => {
    const mutationKey = [
      'createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost
        >
      >,
      { ticketId: string }
    > = (props) => {
      const { ticketId } = props ?? {};

      return createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost(
        ticketId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost
      >
    >
  >;

export type CreateWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Work Item From Ticket
 */
export const useCreateWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost
          >
        >,
        TError,
        { ticketId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPost
      >
    >,
    TError,
    { ticketId: string },
    TContext
  > => {
    const mutationOptions =
      getCreateWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Link this ticket to a work item that already exists.

Near side: the ticket, which this mutates — edit access, same as the POST
beside it. Far side, the half a near-side gate says nothing about: the work
item id arrives in the BODY, so it is checked against software_factory's own
sharing gate before anything is written. Naming one the caller cannot see 404s,
so "no such work item" and "a work item shared away from you" are answered
identically and the endpoint is not an existence oracle.

VIEWER and not EDITOR, deliberately. The mirror-image surface in this module
(`link_tasks_to_ticket`) settles the same question the same way: attaching a
peer to a ticket costs what SEEING that peer costs, because the record being
changed is the ticket. Demanding edit on the work item would lock the support
agents this feature exists for out of every engineering item they can read but
not write — which is most of them.

Returns the same body as the GET, so the client renders the result of its own
write without a refetch.
 * @summary Link Work Item To Ticket
 */
export const linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut = (
  ticketId: string,
  ticketWorkItemLinkCreate: TicketWorkItemLinkCreate
) => {
  return customInstance<TicketLinkedWorkItemResponse>({
    url: `/api/v1/support/tickets/${ticketId}/work-item`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: ticketWorkItemLinkCreate
  });
};

export const getLinkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut
        >
      >,
      TError,
      { ticketId: string; data: TicketWorkItemLinkCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut
      >
    >,
    TError,
    { ticketId: string; data: TicketWorkItemLinkCreate },
    TContext
  > => {
    const mutationKey = [
      'linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut
        >
      >,
      { ticketId: string; data: TicketWorkItemLinkCreate }
    > = (props) => {
      const { ticketId, data } = props ?? {};

      return linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut(
        ticketId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut
      >
    >
  >;
export type LinkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPutMutationBody =
  TicketWorkItemLinkCreate;
export type LinkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPutMutationError =
  HTTPValidationError;

/**
 * @summary Link Work Item To Ticket
 */
export const useLinkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut
        >
      >,
      TError,
      { ticketId: string; data: TicketWorkItemLinkCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof linkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPut
    >
  >,
  TError,
  { ticketId: string; data: TicketWorkItemLinkCreate },
  TContext
> => {
  const mutationOptions =
    getLinkWorkItemToTicketApiV1SupportTicketsTicketIdWorkItemPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get the work item linked to this ticket.

Near side: ticket read access, 404-hiding in a restricted mode. Far side: the
work item is resolved through software_factory's own scoped read, so a link to
an item this caller may not see reads as no link at all rather than leaking its
title — the same `null` a ticket with no link and a ticket whose work item was
deleted both give.
 * @summary Get Linked Work Item
 */
export const getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<TicketLinkedWorkItemResponse>({
    url: `/api/v1/support/tickets/${ticketId}/work-item`,
    method: 'GET',
    signal
  });
};

export const getGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGetQueryKey =
  (ticketId?: string) => {
    return [`/api/v1/support/tickets/${ticketId}/work-item`] as const;
  };

export const getGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet>
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGetQueryKey(
        ticketId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
        >
      >
    > = ({ signal }) =>
      getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet(ticketId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!ticketId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet>
    >
  >;
export type GetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGetQueryError =
  HTTPValidationError;

export function useGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet<
  TData = Awaited<
    ReturnType<typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet<
  TData = Awaited<
    ReturnType<typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet<
  TData = Awaited<
    ReturnType<typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Linked Work Item
 */

export function useGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet<
  TData = Awaited<
    ReturnType<typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLinkedWorkItemApiV1SupportTicketsTicketIdWorkItemGetQueryOptions(
      ticketId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Detach this ticket from its work item. Requires edit access on the ticket.

No far-side check, and that is the contract rather than an omission: requiring
visibility of the work item to DETACH it would leave a ticket's own editor
unable to clear a link whose work item was later shared away from them. Removal
reveals nothing.

Idempotent — unlinking a ticket that has no link is a success, because the
caller's intent ("this link should not exist") is satisfied either way. Returns
the post-state (`linked_work_item: null`), so the client seeds its cache from
the same shape the GET returns.
 * @summary Unlink Work Item From Ticket
 */
export const unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete =
  (ticketId: string) => {
    return customInstance<TicketLinkedWorkItemResponse>({
      url: `/api/v1/support/tickets/${ticketId}/work-item`,
      method: 'DELETE'
    });
  };

export const getUnlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete
        >
      >,
      TError,
      { ticketId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete
      >
    >,
    TError,
    { ticketId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete
        >
      >,
      { ticketId: string }
    > = (props) => {
      const { ticketId } = props ?? {};

      return unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete(
        ticketId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete
      >
    >
  >;

export type UnlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Work Item From Ticket
 */
export const useUnlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete
          >
        >,
        TError,
        { ticketId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDelete
      >
    >,
    TError,
    { ticketId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkWorkItemFromTicketApiV1SupportTicketsTicketIdWorkItemDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the tasks linked to this ticket.

Near side: ticket read access, 404-hiding in a restricted mode. Far side: each
task is dropped unless the caller is a member of its board.
 * @summary List Ticket Linked Tasks
 */
export const listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<TicketLinkedTaskListResponse>({
    url: `/api/v1/support/tickets/${ticketId}/tasks`,
    method: 'GET',
    signal
  });
};

export const getListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGetQueryKey =
  (ticketId?: string) => {
    return [`/api/v1/support/tickets/${ticketId}/tasks`] as const;
  };

export const getListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
      >
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGetQueryKey(
        ticketId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
        >
      >
    > = ({ signal }) =>
      listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet(
        ticketId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!ticketId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
      >
    >
  >;
export type ListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGetQueryError =
  HTTPValidationError;

export function useListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet<
  TData = Awaited<
    ReturnType<typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet<
  TData = Awaited<
    ReturnType<typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet<
  TData = Awaited<
    ReturnType<typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Ticket Linked Tasks
 */

export function useListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet<
  TData = Awaited<
    ReturnType<typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTicketLinkedTasksApiV1SupportTicketsTicketIdTasksGetQueryOptions(
      ticketId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link tasks to this ticket. Editing the ticket's links requires edit access.

Far side, the half a near-side gate says nothing about: the task ids arrive in
the BODY, so each is checked against the Tasks module's board ReBAC before any
row is written. Naming a task the caller cannot see 404s the WHOLE request
rather than dropping that id — a silent drop would answer "did this id exist?"
one linked-count at a time, and 404 makes "no such task" and "a task on a board
you are not on" indistinguishable, which is the same posture every read gate in
the tree takes.

The company half of that check is the caller's ACCESSIBLE companies, and on
this route the choice matters most: it is a WRITE, so binding it to the app
bar's active company instead would 404 a link the caller is entitled to make
purely because of which company their dropdown happened to be showing.
 * @summary Link Tasks To Ticket
 */
export const linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost = (
  ticketId: string,
  ticketTaskLinkCreate: TicketTaskLinkCreate,
  signal?: AbortSignal
) => {
  return customInstance<TicketLinkedTaskListResponse>({
    url: `/api/v1/support/tickets/${ticketId}/tasks`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ticketTaskLinkCreate,
    signal
  });
};

export const getLinkTasksToTicketApiV1SupportTicketsTicketIdTasksPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost>
      >,
      TError,
      { ticketId: string; data: TicketTaskLinkCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost>
    >,
    TError,
    { ticketId: string; data: TicketTaskLinkCreate },
    TContext
  > => {
    const mutationKey = [
      'linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost>
      >,
      { ticketId: string; data: TicketTaskLinkCreate }
    > = (props) => {
      const { ticketId, data } = props ?? {};

      return linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost(
        ticketId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkTasksToTicketApiV1SupportTicketsTicketIdTasksPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost>
    >
  >;
export type LinkTasksToTicketApiV1SupportTicketsTicketIdTasksPostMutationBody =
  TicketTaskLinkCreate;
export type LinkTasksToTicketApiV1SupportTicketsTicketIdTasksPostMutationError =
  HTTPValidationError;

/**
 * @summary Link Tasks To Ticket
 */
export const useLinkTasksToTicketApiV1SupportTicketsTicketIdTasksPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost>
      >,
      TError,
      { ticketId: string; data: TicketTaskLinkCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof linkTasksToTicketApiV1SupportTicketsTicketIdTasksPost>
  >,
  TError,
  { ticketId: string; data: TicketTaskLinkCreate },
  TContext
> => {
  const mutationOptions =
    getLinkTasksToTicketApiV1SupportTicketsTicketIdTasksPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unlink one task from this ticket. Requires edit access on the ticket.

No far-side check, and that is the contract rather than an omission: requiring
visibility of the task to DETACH it would leave a ticket's own editor unable to
remove a link whose task was later moved to a board they are not on. Removal
reveals nothing (`docs/platform/entity-relationship-surfaces-design.md` § 5).

Idempotent — unlinking a task that is not linked is a success, because the
caller's intent ("this link should not exist") is satisfied either way and a
404 here would report the link's existence to someone already allowed to
destroy it.
 * @summary Unlink Task From Ticket
 */
export const unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete =
  (ticketId: string, taskId: string) => {
    return customInstance<TicketLinkedTaskListResponse>({
      url: `/api/v1/support/tickets/${ticketId}/tasks/${taskId}`,
      method: 'DELETE'
    });
  };

export const getUnlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete
        >
      >,
      TError,
      { ticketId: string; taskId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete
      >
    >,
    TError,
    { ticketId: string; taskId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete
        >
      >,
      { ticketId: string; taskId: string }
    > = (props) => {
      const { ticketId, taskId } = props ?? {};

      return unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete(
        ticketId,
        taskId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete
      >
    >
  >;

export type UnlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Task From Ticket
 */
export const useUnlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete
          >
        >,
        TError,
        { ticketId: string; taskId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDelete
      >
    >,
    TError,
    { ticketId: string; taskId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkTaskFromTicketApiV1SupportTicketsTicketIdTasksTaskIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the support tickets linked to this task — the link's OTHER end.

Near side is the task, whose visibility is the Tasks module's answer (404 when
the caller is not on its board). Far side is the tickets, filtered by the
caller's ticket sharing scope, so a task shared widely never becomes a way to
enumerate tickets that are not.
 * @summary List Task Linked Tickets
 */
export const listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet = (
  taskId: string,
  signal?: AbortSignal
) => {
  return customInstance<TaskLinkedTicketListResponse>({
    url: `/api/v1/support/tasks/${taskId}/tickets`,
    method: 'GET',
    signal
  });
};

export const getListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGetQueryKey =
  (taskId?: string) => {
    return [`/api/v1/support/tasks/${taskId}/tickets`] as const;
  };

export const getListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet>
    >,
    TError = HTTPValidationError
  >(
    taskId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGetQueryKey(taskId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
        >
      >
    > = ({ signal }) =>
      listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet(taskId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!taskId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet>
    >
  >;
export type ListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGetQueryError =
  HTTPValidationError;

export function useListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet>
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet>
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet>
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Task Linked Tickets
 */

export function useListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet<
  TData = Awaited<
    ReturnType<typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet>
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTaskLinkedTicketsApiV1SupportTasksTaskIdTicketsGetQueryOptions(
      taskId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Unlink one ticket from this task — the same removal, reached from the task.

Gated on BOTH ends, which is stricter than the § 5 "editor on A only" rule for
a reason worth stating: the row being destroyed lives in the ticket's junction,
so the ticket's own edit gate is what governs it no matter which URL the caller
came in through. Requiring only a task relation would let a task editor detach
a ticket they may not even read. In `everyone` mode — the default, and every
tenant that has not opted into restricted ticket visibility — the ticket half
is a no-op, so this costs nothing in practice and only binds where it matters.
 * @summary Unlink Ticket From Task
 */
export const unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete =
  (taskId: string, ticketId: string) => {
    return customInstance<TaskLinkedTicketListResponse>({
      url: `/api/v1/support/tasks/${taskId}/tickets/${ticketId}`,
      method: 'DELETE'
    });
  };

export const getUnlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete
        >
      >,
      TError,
      { taskId: string; ticketId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete
      >
    >,
    TError,
    { taskId: string; ticketId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete
        >
      >,
      { taskId: string; ticketId: string }
    > = (props) => {
      const { taskId, ticketId } = props ?? {};

      return unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete(
        taskId,
        ticketId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete
      >
    >
  >;

export type UnlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Ticket From Task
 */
export const useUnlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete
          >
        >,
        TError,
        { taskId: string; ticketId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDelete
      >
    >,
    TError,
    { taskId: string; ticketId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkTicketFromTaskApiV1SupportTasksTaskIdTicketsTicketIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Bulk update tickets, over an explicit id list or the whole filter set.

``match_all_filtered`` resolves the SAME filtered query the list page renders
(``TicketService._apply_ticket_filters``) to a bounded id set, then hands it to
the same set-based service method the id path uses — so the two cannot drift.
Bounded by ``BULK_MATCHING_MAX_AFFECTED``; over that the call is refused rather
than truncated.

This route used to lower that ceiling to the id-list cap, because every status
change fanned out an INLINE customer email — per-item network I/O inside a
request the gateway caps at 60s. The send now happens off the request thread
(``customer_notification_dispatch`` enqueues, ``poll_customer_notification_jobs``
drains), so the binding constraint is once again "how many rows fit in one
UPDATE" and tickets resolves at the shared ceiling like every other adopter.
 * @summary Bulk Update Tickets
 */
export const bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost = (
  bulkUpdateRequest: BulkUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/bulk-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkUpdateRequest,
    signal
  });
};

export const getBulkUpdateTicketsApiV1SupportTicketsBulkUpdatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost>
      >,
      TError,
      { data: BulkUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost>
    >,
    TError,
    { data: BulkUpdateRequest },
    TContext
  > => {
    const mutationKey = ['bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost>
      >,
      { data: BulkUpdateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkUpdateTicketsApiV1SupportTicketsBulkUpdatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost>
    >
  >;
export type BulkUpdateTicketsApiV1SupportTicketsBulkUpdatePostMutationBody =
  BulkUpdateRequest;
export type BulkUpdateTicketsApiV1SupportTicketsBulkUpdatePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Update Tickets
 */
export const useBulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost>
      >,
      TError,
      { data: BulkUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkUpdateTicketsApiV1SupportTicketsBulkUpdatePost>
  >,
  TError,
  { data: BulkUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getBulkUpdateTicketsApiV1SupportTicketsBulkUpdatePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bulk delete multiple tickets.

Non-empty and ≤ ``BULK_IDS_MAX`` are enforced by ``BulkIdsRequest``'s own
field constraints, so they are a 422 at the wire rather than a hand-written
check each bulk author has to remember to copy.
 * @summary Bulk Delete Tickets
 */
export const bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost = (
  bulkDeleteRequest: BulkDeleteRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/bulk-delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDeleteRequest,
    signal
  });
};

export const getBulkDeleteTicketsApiV1SupportTicketsBulkDeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost>
      >,
      TError,
      { data: BulkDeleteRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost>
    >,
    TError,
    { data: BulkDeleteRequest },
    TContext
  > => {
    const mutationKey = ['bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost>
      >,
      { data: BulkDeleteRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkDeleteTicketsApiV1SupportTicketsBulkDeletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost>
    >
  >;
export type BulkDeleteTicketsApiV1SupportTicketsBulkDeletePostMutationBody =
  BulkDeleteRequest;
export type BulkDeleteTicketsApiV1SupportTicketsBulkDeletePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Delete Tickets
 */
export const useBulkDeleteTicketsApiV1SupportTicketsBulkDeletePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost>
      >,
      TError,
      { data: BulkDeleteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkDeleteTicketsApiV1SupportTicketsBulkDeletePost>
  >,
  TError,
  { data: BulkDeleteRequest },
  TContext
> => {
  const mutationOptions =
    getBulkDeleteTicketsApiV1SupportTicketsBulkDeletePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all attachments for a ticket.
 * @summary List Ticket Attachments
 */
export const listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/tickets/${ticketId}/attachments`,
    method: 'GET',
    signal
  });
};

export const getListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGetQueryKey =
  (ticketId?: string) => {
    return [`/api/v1/support/tickets/${ticketId}/attachments`] as const;
  };

export const getListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGetQueryKey(
        ticketId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
        >
      >
    > = ({ signal }) =>
      listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet(
        ticketId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!ticketId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
      >
    >
  >;
export type ListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGetQueryError =
  HTTPValidationError;

export function useListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Ticket Attachments
 */

export function useListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTicketAttachmentsApiV1SupportTicketsTicketIdAttachmentsGetQueryOptions(
      ticketId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload an attachment to a ticket.

Uses the file management module for storage with backlinks.
The file will be stored with attached_to = "support_tickets:{ticket_id}".
 * @summary Upload Ticket Attachment
 */
export const uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost =
  (
    ticketId: string,
    bodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost: BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost,
    signal?: AbortSignal
  ) => {
    const formData = new FormData();
    formData.append(
      `file`,
      bodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost.file
    );
    if (
      bodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost.message_id !==
        undefined &&
      bodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost.message_id !==
        null
    ) {
      formData.append(
        `message_id`,
        bodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost.message_id
      );
    }

    return customInstance<unknown>({
      url: `/api/v1/support/tickets/${ticketId}/attachments`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal
    });
  };

export const getUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost
        >
      >,
      TError,
      {
        ticketId: string;
        data: BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost
      >
    >,
    TError,
    {
      ticketId: string;
      data: BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost;
    },
    TContext
  > => {
    const mutationKey = [
      'uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost
        >
      >,
      {
        ticketId: string;
        data: BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost;
      }
    > = (props) => {
      const { ticketId, data } = props ?? {};

      return uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost(
        ticketId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost
      >
    >
  >;
export type UploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPostMutationBody =
  BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost;
export type UploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Upload Ticket Attachment
 */
export const useUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost
          >
        >,
        TError,
        {
          ticketId: string;
          data: BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof uploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost
      >
    >,
    TError,
    {
      ticketId: string;
      data: BodyUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPost;
    },
    TContext
  > => {
    const mutationOptions =
      getUploadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get attachment metadata.
 * @summary Get Ticket Attachment
 */
export const getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet =
  (ticketId: string, attachmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/support/tickets/${ticketId}/attachments/${attachmentId}`,
      method: 'GET',
      signal
    });
  };

export const getGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGetQueryKey =
  (ticketId?: string, attachmentId?: string) => {
    return [
      `/api/v1/support/tickets/${ticketId}/attachments/${attachmentId}`
    ] as const;
  };

export const getGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    attachmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGetQueryKey(
        ticketId,
        attachmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
        >
      >
    > = ({ signal }) =>
      getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet(
        ticketId,
        attachmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(ticketId && attachmentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
      >
    >
  >;
export type GetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGetQueryError =
  HTTPValidationError;

export function useGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ticket Attachment
 */

export function useGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdGetQueryOptions(
      ticketId,
      attachmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete an attachment from a ticket.
 * @summary Delete Ticket Attachment
 */
export const deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete =
  (ticketId: string, attachmentId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/support/tickets/${ticketId}/attachments/${attachmentId}`,
      method: 'DELETE'
    });
  };

export const getDeleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete
        >
      >,
      TError,
      { ticketId: string; attachmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete
      >
    >,
    TError,
    { ticketId: string; attachmentId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete
        >
      >,
      { ticketId: string; attachmentId: string }
    > = (props) => {
      const { ticketId, attachmentId } = props ?? {};

      return deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete(
        ticketId,
        attachmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete
      >
    >
  >;

export type DeleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Ticket Attachment
 */
export const useDeleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete
          >
        >,
        TError,
        { ticketId: string; attachmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDelete
      >
    >,
    TError,
    { ticketId: string; attachmentId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Download attachment file content.
 * @summary Download Ticket Attachment
 */
export const downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet =
  (ticketId: string, attachmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/support/tickets/${ticketId}/attachments/${attachmentId}/download`,
      method: 'GET',
      signal
    });
  };

export const getDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGetQueryKey =
  (ticketId?: string, attachmentId?: string) => {
    return [
      `/api/v1/support/tickets/${ticketId}/attachments/${attachmentId}/download`
    ] as const;
  };

export const getDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
      >
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    attachmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGetQueryKey(
        ticketId,
        attachmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
        >
      >
    > = ({ signal }) =>
      downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet(
        ticketId,
        attachmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(ticketId && attachmentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
      >
    >
  >;
export type DownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGetQueryError =
  HTTPValidationError;

export function useDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Ticket Attachment
 */

export function useDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadTicketAttachmentApiV1SupportTicketsTicketIdAttachmentsAttachmentIdDownloadGetQueryOptions(
      ticketId,
      attachmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all files linked to a ticket via backlinks.

Returns files from the file management module that have
attached_to = "support_tickets:{ticket_id}", narrowed to the files this caller
may open. `total` is the length of that filtered list.
 * @summary Get Ticket Backlinks
 */
export const getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet = (
  ticketId: string,
  signal?: AbortSignal
) => {
  return customInstance<TicketLinkedFileListResponse>({
    url: `/api/v1/support/tickets/${ticketId}/files`,
    method: 'GET',
    signal
  });
};

export const getGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGetQueryKey =
  (ticketId?: string) => {
    return [`/api/v1/support/tickets/${ticketId}/files`] as const;
  };

export const getGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
    >,
    TError = HTTPValidationError
  >(
    ticketId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGetQueryKey(
        ticketId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
      >
    > = ({ signal }) =>
      getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet(ticketId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!ticketId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTicketBacklinksApiV1SupportTicketsTicketIdFilesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
    >
  >;
export type GetTicketBacklinksApiV1SupportTicketsTicketIdFilesGetQueryError =
  HTTPValidationError;

export function useGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGet<
  TData = Awaited<
    ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGet<
  TData = Awaited<
    ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGet<
  TData = Awaited<
    ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ticket Backlinks
 */

export function useGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGet<
  TData = Awaited<
    ReturnType<typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet>
  >,
  TError = HTTPValidationError
>(
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTicketBacklinksApiV1SupportTicketsTicketIdFilesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTicketBacklinksApiV1SupportTicketsTicketIdFilesGetQueryOptions(
      ticketId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List SLA policies.
 * @summary List Sla Policies
 */
export const listSlaPoliciesApiV1SupportSlaPoliciesGet = (
  params?: ListSlaPoliciesApiV1SupportSlaPoliciesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/sla-policies`,
    method: 'GET',
    params,
    signal
  });
};

export const getListSlaPoliciesApiV1SupportSlaPoliciesGetQueryKey = (
  params?: ListSlaPoliciesApiV1SupportSlaPoliciesGetParams
) => {
  return [`/api/v1/support/sla-policies`, ...(params ? [params] : [])] as const;
};

export const getListSlaPoliciesApiV1SupportSlaPoliciesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
  TError = HTTPValidationError
>(
  params?: ListSlaPoliciesApiV1SupportSlaPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSlaPoliciesApiV1SupportSlaPoliciesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>
  > = ({ signal }) => listSlaPoliciesApiV1SupportSlaPoliciesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListSlaPoliciesApiV1SupportSlaPoliciesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>
>;
export type ListSlaPoliciesApiV1SupportSlaPoliciesGetQueryError =
  HTTPValidationError;

export function useListSlaPoliciesApiV1SupportSlaPoliciesGet<
  TData = Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListSlaPoliciesApiV1SupportSlaPoliciesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
          TError,
          Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSlaPoliciesApiV1SupportSlaPoliciesGet<
  TData = Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
  TError = HTTPValidationError
>(
  params?: ListSlaPoliciesApiV1SupportSlaPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
          TError,
          Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSlaPoliciesApiV1SupportSlaPoliciesGet<
  TData = Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
  TError = HTTPValidationError
>(
  params?: ListSlaPoliciesApiV1SupportSlaPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Sla Policies
 */

export function useListSlaPoliciesApiV1SupportSlaPoliciesGet<
  TData = Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
  TError = HTTPValidationError
>(
  params?: ListSlaPoliciesApiV1SupportSlaPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSlaPoliciesApiV1SupportSlaPoliciesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListSlaPoliciesApiV1SupportSlaPoliciesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an SLA policy.
 * @summary Create Sla Policy
 */
export const createSlaPolicyApiV1SupportSlaPoliciesPost = (
  sLAPolicyCreate: SLAPolicyCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/sla-policies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sLAPolicyCreate,
    signal
  });
};

export const getCreateSlaPolicyApiV1SupportSlaPoliciesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSlaPolicyApiV1SupportSlaPoliciesPost>>,
    TError,
    { data: SLAPolicyCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSlaPolicyApiV1SupportSlaPoliciesPost>>,
  TError,
  { data: SLAPolicyCreate },
  TContext
> => {
  const mutationKey = ['createSlaPolicyApiV1SupportSlaPoliciesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSlaPolicyApiV1SupportSlaPoliciesPost>>,
    { data: SLAPolicyCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createSlaPolicyApiV1SupportSlaPoliciesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSlaPolicyApiV1SupportSlaPoliciesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createSlaPolicyApiV1SupportSlaPoliciesPost>>
  >;
export type CreateSlaPolicyApiV1SupportSlaPoliciesPostMutationBody =
  SLAPolicyCreate;
export type CreateSlaPolicyApiV1SupportSlaPoliciesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Sla Policy
 */
export const useCreateSlaPolicyApiV1SupportSlaPoliciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSlaPolicyApiV1SupportSlaPoliciesPost>>,
      TError,
      { data: SLAPolicyCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSlaPolicyApiV1SupportSlaPoliciesPost>>,
  TError,
  { data: SLAPolicyCreate },
  TContext
> => {
  const mutationOptions =
    getCreateSlaPolicyApiV1SupportSlaPoliciesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get an SLA policy.
 * @summary Get Sla Policy
 */
export const getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet = (
  policyId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/sla-policies/${policyId}`,
    method: 'GET',
    signal
  });
};

export const getGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGetQueryKey = (
  policyId?: string
) => {
  return [`/api/v1/support/sla-policies/${policyId}`] as const;
};

export const getGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGetQueryKey(policyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>>
  > = ({ signal }) =>
    getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet(policyId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!policyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>>
  >;
export type GetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGetQueryError =
  HTTPValidationError;

export function useGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sla Policy
 */

export function useGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSlaPolicyApiV1SupportSlaPoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSlaPolicyApiV1SupportSlaPoliciesPolicyIdGetQueryOptions(
      policyId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an SLA policy.
 * @summary Update Sla Policy
 */
export const updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut = (
  policyId: string,
  sLAPolicyUpdate: SLAPolicyUpdate
) => {
  return customInstance<SLAPolicyResponse>({
    url: `/api/v1/support/sla-policies/${policyId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sLAPolicyUpdate
  });
};

export const getUpdateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut>
      >,
      TError,
      { policyId: string; data: SLAPolicyUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut>
    >,
    TError,
    { policyId: string; data: SLAPolicyUpdate },
    TContext
  > => {
    const mutationKey = ['updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut>
      >,
      { policyId: string; data: SLAPolicyUpdate }
    > = (props) => {
      const { policyId, data } = props ?? {};

      return updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut(policyId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut>
    >
  >;
export type UpdateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPutMutationBody =
  SLAPolicyUpdate;
export type UpdateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Sla Policy
 */
export const useUpdateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut>
      >,
      TError,
      { policyId: string; data: SLAPolicyUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPut>>,
  TError,
  { policyId: string; data: SLAPolicyUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSlaPolicyApiV1SupportSlaPoliciesPolicyIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete an SLA policy.
 * @summary Delete Sla Policy
 */
export const deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete = (
  policyId: string
) => {
  return customInstance<void>({
    url: `/api/v1/support/sla-policies/${policyId}`,
    method: 'DELETE'
  });
};

export const getDeleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete>
      >,
      TError,
      { policyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete>
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete>
      >,
      { policyId: string }
    > = (props) => {
      const { policyId } = props ?? {};

      return deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete(policyId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete>
    >
  >;

export type DeleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Sla Policy
 */
export const useDeleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete>
      >,
      TError,
      { policyId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDelete>
  >,
  TError,
  { policyId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteSlaPolicyApiV1SupportSlaPoliciesPolicyIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all support agents with their configurations.
 * @summary List Agents
 */
export const listAgentsApiV1SupportAgentsGet = (
  params?: ListAgentsApiV1SupportAgentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/agents`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAgentsApiV1SupportAgentsGetQueryKey = (
  params?: ListAgentsApiV1SupportAgentsGetParams
) => {
  return [`/api/v1/support/agents`, ...(params ? [params] : [])] as const;
};

export const getListAgentsApiV1SupportAgentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1SupportAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAgentsApiV1SupportAgentsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>
  > = ({ signal }) => listAgentsApiV1SupportAgentsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAgentsApiV1SupportAgentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>
>;
export type ListAgentsApiV1SupportAgentsGetQueryError = HTTPValidationError;

export function useListAgentsApiV1SupportAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListAgentsApiV1SupportAgentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
          TError,
          Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAgentsApiV1SupportAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1SupportAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
          TError,
          Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAgentsApiV1SupportAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1SupportAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Agents
 */

export function useListAgentsApiV1SupportAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1SupportAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1SupportAgentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAgentsApiV1SupportAgentsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get users who can be added as support agents.
 * @summary Get Available Users
 */
export const getAvailableUsersApiV1SupportAgentsAvailableUsersGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/agents/available-users`,
    method: 'GET',
    signal
  });
};

export const getGetAvailableUsersApiV1SupportAgentsAvailableUsersGetQueryKey =
  () => {
    return [`/api/v1/support/agents/available-users`] as const;
  };

export const getGetAvailableUsersApiV1SupportAgentsAvailableUsersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAvailableUsersApiV1SupportAgentsAvailableUsersGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
      >
    > = ({ signal }) =>
      getAvailableUsersApiV1SupportAgentsAvailableUsersGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAvailableUsersApiV1SupportAgentsAvailableUsersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
    >
  >;
export type GetAvailableUsersApiV1SupportAgentsAvailableUsersGetQueryError =
  unknown;

export function useGetAvailableUsersApiV1SupportAgentsAvailableUsersGet<
  TData = Awaited<
    ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvailableUsersApiV1SupportAgentsAvailableUsersGet<
  TData = Awaited<
    ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableUsersApiV1SupportAgentsAvailableUsersGet<
  TData = Awaited<
    ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Available Users
 */

export function useGetAvailableUsersApiV1SupportAgentsAvailableUsersGet<
  TData = Awaited<
    ReturnType<typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableUsersApiV1SupportAgentsAvailableUsersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAvailableUsersApiV1SupportAgentsAvailableUsersGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a specific agent's configuration.
 * @summary Get Agent
 */
export const getAgentApiV1SupportAgentsUserIdGet = (
  userId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/agents/${userId}`,
    method: 'GET',
    signal
  });
};

export const getGetAgentApiV1SupportAgentsUserIdGetQueryKey = (
  userId?: string
) => {
  return [`/api/v1/support/agents/${userId}`] as const;
};

export const getGetAgentApiV1SupportAgentsUserIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAgentApiV1SupportAgentsUserIdGetQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>
  > = ({ signal }) => getAgentApiV1SupportAgentsUserIdGet(userId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAgentApiV1SupportAgentsUserIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>
>;
export type GetAgentApiV1SupportAgentsUserIdGetQueryError = HTTPValidationError;

export function useGetAgentApiV1SupportAgentsUserIdGet<
  TData = Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
          TError,
          Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAgentApiV1SupportAgentsUserIdGet<
  TData = Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
          TError,
          Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentApiV1SupportAgentsUserIdGet<
  TData = Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Agent
 */

export function useGetAgentApiV1SupportAgentsUserIdGet<
  TData = Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgentApiV1SupportAgentsUserIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAgentApiV1SupportAgentsUserIdGetQueryOptions(
    userId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an agent's configuration (creates if not exists).
 * @summary Update Agent
 */
export const updateAgentApiV1SupportAgentsUserIdPut = (
  userId: string,
  agentConfigUpdate: AgentConfigUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/agents/${userId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: agentConfigUpdate
  });
};

export const getUpdateAgentApiV1SupportAgentsUserIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAgentApiV1SupportAgentsUserIdPut>>,
    TError,
    { userId: string; data: AgentConfigUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAgentApiV1SupportAgentsUserIdPut>>,
  TError,
  { userId: string; data: AgentConfigUpdate },
  TContext
> => {
  const mutationKey = ['updateAgentApiV1SupportAgentsUserIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAgentApiV1SupportAgentsUserIdPut>>,
    { userId: string; data: AgentConfigUpdate }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateAgentApiV1SupportAgentsUserIdPut(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAgentApiV1SupportAgentsUserIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAgentApiV1SupportAgentsUserIdPut>>
>;
export type UpdateAgentApiV1SupportAgentsUserIdPutMutationBody =
  AgentConfigUpdate;
export type UpdateAgentApiV1SupportAgentsUserIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Agent
 */
export const useUpdateAgentApiV1SupportAgentsUserIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAgentApiV1SupportAgentsUserIdPut>>,
      TError,
      { userId: string; data: AgentConfigUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAgentApiV1SupportAgentsUserIdPut>>,
  TError,
  { userId: string; data: AgentConfigUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateAgentApiV1SupportAgentsUserIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a new agent configuration for a user.
 * @summary Create Agent
 */
export const createAgentApiV1SupportAgentsUserIdPost = (
  userId: string,
  agentConfigUpdate: AgentConfigUpdate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/agents/${userId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: agentConfigUpdate,
    signal
  });
};

export const getCreateAgentApiV1SupportAgentsUserIdPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgentApiV1SupportAgentsUserIdPost>>,
    TError,
    { userId: string; data: AgentConfigUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAgentApiV1SupportAgentsUserIdPost>>,
  TError,
  { userId: string; data: AgentConfigUpdate },
  TContext
> => {
  const mutationKey = ['createAgentApiV1SupportAgentsUserIdPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAgentApiV1SupportAgentsUserIdPost>>,
    { userId: string; data: AgentConfigUpdate }
  > = (props) => {
    const { userId, data } = props ?? {};

    return createAgentApiV1SupportAgentsUserIdPost(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAgentApiV1SupportAgentsUserIdPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAgentApiV1SupportAgentsUserIdPost>>
>;
export type CreateAgentApiV1SupportAgentsUserIdPostMutationBody =
  AgentConfigUpdate;
export type CreateAgentApiV1SupportAgentsUserIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Agent
 */
export const useCreateAgentApiV1SupportAgentsUserIdPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAgentApiV1SupportAgentsUserIdPost>>,
      TError,
      { userId: string; data: AgentConfigUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAgentApiV1SupportAgentsUserIdPost>>,
  TError,
  { userId: string; data: AgentConfigUpdate },
  TContext
> => {
  const mutationOptions =
    getCreateAgentApiV1SupportAgentsUserIdPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove a user from support agents.
 * @summary Delete Agent
 */
export const deleteAgentApiV1SupportAgentsUserIdDelete = (userId: string) => {
  return customInstance<unknown>({
    url: `/api/v1/support/agents/${userId}`,
    method: 'DELETE'
  });
};

export const getDeleteAgentApiV1SupportAgentsUserIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentApiV1SupportAgentsUserIdDelete>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgentApiV1SupportAgentsUserIdDelete>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['deleteAgentApiV1SupportAgentsUserIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgentApiV1SupportAgentsUserIdDelete>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteAgentApiV1SupportAgentsUserIdDelete(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentApiV1SupportAgentsUserIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteAgentApiV1SupportAgentsUserIdDelete>>
  >;

export type DeleteAgentApiV1SupportAgentsUserIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Agent
 */
export const useDeleteAgentApiV1SupportAgentsUserIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAgentApiV1SupportAgentsUserIdDelete>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAgentApiV1SupportAgentsUserIdDelete>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteAgentApiV1SupportAgentsUserIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Toggle an agent's availability status.
 * @summary Toggle Agent Availability
 */
export const toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost =
  (userId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/support/agents/${userId}/toggle-availability`,
      method: 'POST',
      signal
    });
  };

export const getToggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost
        >
      >,
      TError,
      { userId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost
      >
    >,
    TError,
    { userId: string },
    TContext
  > => {
    const mutationKey = [
      'toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost
        >
      >,
      { userId: string }
    > = (props) => {
      const { userId } = props ?? {};

      return toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost(
        userId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ToggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost
      >
    >
  >;

export type ToggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPostMutationError =
  HTTPValidationError;

/**
 * @summary Toggle Agent Availability
 */
export const useToggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost
          >
        >,
        TError,
        { userId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof toggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPost
      >
    >,
    TError,
    { userId: string },
    TContext
  > => {
    const mutationOptions =
      getToggleAgentAvailabilityApiV1SupportAgentsUserIdToggleAvailabilityPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all routing rules for the tenant.
 * @summary List Routing Rules
 */
export const listRoutingRulesApiV1SupportRoutingRulesGet = (
  params?: ListRoutingRulesApiV1SupportRoutingRulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/routing-rules`,
    method: 'GET',
    params,
    signal
  });
};

export const getListRoutingRulesApiV1SupportRoutingRulesGetQueryKey = (
  params?: ListRoutingRulesApiV1SupportRoutingRulesGetParams
) => {
  return [
    `/api/v1/support/routing-rules`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListRoutingRulesApiV1SupportRoutingRulesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRoutingRulesApiV1SupportRoutingRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRoutingRulesApiV1SupportRoutingRulesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>
  > = ({ signal }) =>
    listRoutingRulesApiV1SupportRoutingRulesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRoutingRulesApiV1SupportRoutingRulesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>
  >;
export type ListRoutingRulesApiV1SupportRoutingRulesGetQueryError =
  HTTPValidationError;

export function useListRoutingRulesApiV1SupportRoutingRulesGet<
  TData = Awaited<
    ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListRoutingRulesApiV1SupportRoutingRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRoutingRulesApiV1SupportRoutingRulesGet<
  TData = Awaited<
    ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRoutingRulesApiV1SupportRoutingRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRoutingRulesApiV1SupportRoutingRulesGet<
  TData = Awaited<
    ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRoutingRulesApiV1SupportRoutingRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Routing Rules
 */

export function useListRoutingRulesApiV1SupportRoutingRulesGet<
  TData = Awaited<
    ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRoutingRulesApiV1SupportRoutingRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRoutingRulesApiV1SupportRoutingRulesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRoutingRulesApiV1SupportRoutingRulesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new routing rule.
 * @summary Create Routing Rule
 */
export const createRoutingRuleApiV1SupportRoutingRulesPost = (
  routingRuleCreate: RoutingRuleCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/routing-rules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: routingRuleCreate,
    signal
  });
};

export const getCreateRoutingRuleApiV1SupportRoutingRulesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRoutingRuleApiV1SupportRoutingRulesPost>>,
    TError,
    { data: RoutingRuleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRoutingRuleApiV1SupportRoutingRulesPost>>,
  TError,
  { data: RoutingRuleCreate },
  TContext
> => {
  const mutationKey = ['createRoutingRuleApiV1SupportRoutingRulesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRoutingRuleApiV1SupportRoutingRulesPost>>,
    { data: RoutingRuleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createRoutingRuleApiV1SupportRoutingRulesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoutingRuleApiV1SupportRoutingRulesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createRoutingRuleApiV1SupportRoutingRulesPost>>
  >;
export type CreateRoutingRuleApiV1SupportRoutingRulesPostMutationBody =
  RoutingRuleCreate;
export type CreateRoutingRuleApiV1SupportRoutingRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Routing Rule
 */
export const useCreateRoutingRuleApiV1SupportRoutingRulesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRoutingRuleApiV1SupportRoutingRulesPost>>,
      TError,
      { data: RoutingRuleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createRoutingRuleApiV1SupportRoutingRulesPost>>,
  TError,
  { data: RoutingRuleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateRoutingRuleApiV1SupportRoutingRulesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a specific routing rule.
 * @summary Get Routing Rule
 */
export const getRoutingRuleApiV1SupportRoutingRulesRuleIdGet = (
  ruleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/routing-rules/${ruleId}`,
    method: 'GET',
    signal
  });
};

export const getGetRoutingRuleApiV1SupportRoutingRulesRuleIdGetQueryKey = (
  ruleId?: string
) => {
  return [`/api/v1/support/routing-rules/${ruleId}`] as const;
};

export const getGetRoutingRuleApiV1SupportRoutingRulesRuleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoutingRuleApiV1SupportRoutingRulesRuleIdGetQueryKey(ruleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>>
  > = ({ signal }) =>
    getRoutingRuleApiV1SupportRoutingRulesRuleIdGet(ruleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!ruleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRoutingRuleApiV1SupportRoutingRulesRuleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>>
  >;
export type GetRoutingRuleApiV1SupportRoutingRulesRuleIdGetQueryError =
  HTTPValidationError;

export function useGetRoutingRuleApiV1SupportRoutingRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRoutingRuleApiV1SupportRoutingRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRoutingRuleApiV1SupportRoutingRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Routing Rule
 */

export function useGetRoutingRuleApiV1SupportRoutingRulesRuleIdGet<
  TData = Awaited<
    ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
  >,
  TError = HTTPValidationError
>(
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRoutingRuleApiV1SupportRoutingRulesRuleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRoutingRuleApiV1SupportRoutingRulesRuleIdGetQueryOptions(
      ruleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a routing rule.
 * @summary Update Routing Rule
 */
export const updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut = (
  ruleId: string,
  routingRuleUpdate: RoutingRuleUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/routing-rules/${ruleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: routingRuleUpdate
  });
};

export const getUpdateRoutingRuleApiV1SupportRoutingRulesRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut>
      >,
      TError,
      { ruleId: string; data: RoutingRuleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut>
    >,
    TError,
    { ruleId: string; data: RoutingRuleUpdate },
    TContext
  > => {
    const mutationKey = ['updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut>
      >,
      { ruleId: string; data: RoutingRuleUpdate }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut(ruleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateRoutingRuleApiV1SupportRoutingRulesRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut>
    >
  >;
export type UpdateRoutingRuleApiV1SupportRoutingRulesRuleIdPutMutationBody =
  RoutingRuleUpdate;
export type UpdateRoutingRuleApiV1SupportRoutingRulesRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Routing Rule
 */
export const useUpdateRoutingRuleApiV1SupportRoutingRulesRuleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut>
      >,
      TError,
      { ruleId: string; data: RoutingRuleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateRoutingRuleApiV1SupportRoutingRulesRuleIdPut>
  >,
  TError,
  { ruleId: string; data: RoutingRuleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateRoutingRuleApiV1SupportRoutingRulesRuleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a routing rule.
 * @summary Delete Routing Rule
 */
export const deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete = (
  ruleId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/routing-rules/${ruleId}`,
    method: 'DELETE'
  });
};

export const getDeleteRoutingRuleApiV1SupportRoutingRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete>
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete>
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete>
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete(ruleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteRoutingRuleApiV1SupportRoutingRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete>
    >
  >;

export type DeleteRoutingRuleApiV1SupportRoutingRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Routing Rule
 */
export const useDeleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete>
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteRoutingRuleApiV1SupportRoutingRulesRuleIdDelete>
  >,
  TError,
  { ruleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteRoutingRuleApiV1SupportRoutingRulesRuleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reorder routing rules by priority.
 * @summary Reorder Routing Rules
 */
export const reorderRoutingRulesApiV1SupportRoutingRulesReorderPost = (
  reorderRulesRequest: ReorderRulesRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/routing-rules/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reorderRulesRequest,
    signal
  });
};

export const getReorderRoutingRulesApiV1SupportRoutingRulesReorderPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderRoutingRulesApiV1SupportRoutingRulesReorderPost
        >
      >,
      TError,
      { data: ReorderRulesRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof reorderRoutingRulesApiV1SupportRoutingRulesReorderPost>
    >,
    TError,
    { data: ReorderRulesRequest },
    TContext
  > => {
    const mutationKey = [
      'reorderRoutingRulesApiV1SupportRoutingRulesReorderPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderRoutingRulesApiV1SupportRoutingRulesReorderPost
        >
      >,
      { data: ReorderRulesRequest }
    > = (props) => {
      const { data } = props ?? {};

      return reorderRoutingRulesApiV1SupportRoutingRulesReorderPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderRoutingRulesApiV1SupportRoutingRulesReorderPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof reorderRoutingRulesApiV1SupportRoutingRulesReorderPost>
    >
  >;
export type ReorderRoutingRulesApiV1SupportRoutingRulesReorderPostMutationBody =
  ReorderRulesRequest;
export type ReorderRoutingRulesApiV1SupportRoutingRulesReorderPostMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Routing Rules
 */
export const useReorderRoutingRulesApiV1SupportRoutingRulesReorderPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderRoutingRulesApiV1SupportRoutingRulesReorderPost
        >
      >,
      TError,
      { data: ReorderRulesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof reorderRoutingRulesApiV1SupportRoutingRulesReorderPost>
  >,
  TError,
  { data: ReorderRulesRequest },
  TContext
> => {
  const mutationOptions =
    getReorderRoutingRulesApiV1SupportRoutingRulesReorderPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List business hours configurations.
 * @summary List Business Hours
 */
export const listBusinessHoursApiV1SupportBusinessHoursGet = (
  signal?: AbortSignal
) => {
  return customInstance<BusinessHoursResponse[]>({
    url: `/api/v1/support/business-hours`,
    method: 'GET',
    signal
  });
};

export const getListBusinessHoursApiV1SupportBusinessHoursGetQueryKey = () => {
  return [`/api/v1/support/business-hours`] as const;
};

export const getListBusinessHoursApiV1SupportBusinessHoursGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBusinessHoursApiV1SupportBusinessHoursGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>>
  > = ({ signal }) => listBusinessHoursApiV1SupportBusinessHoursGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListBusinessHoursApiV1SupportBusinessHoursGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>>
  >;
export type ListBusinessHoursApiV1SupportBusinessHoursGetQueryError = unknown;

export function useListBusinessHoursApiV1SupportBusinessHoursGet<
  TData = Awaited<
    ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBusinessHoursApiV1SupportBusinessHoursGet<
  TData = Awaited<
    ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBusinessHoursApiV1SupportBusinessHoursGet<
  TData = Awaited<
    ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Business Hours
 */

export function useListBusinessHoursApiV1SupportBusinessHoursGet<
  TData = Awaited<
    ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBusinessHoursApiV1SupportBusinessHoursGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListBusinessHoursApiV1SupportBusinessHoursGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create business hours configuration.
 * @summary Create Business Hours
 */
export const createBusinessHoursApiV1SupportBusinessHoursPost = (
  businessHoursCreate: BusinessHoursCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/business-hours`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: businessHoursCreate,
    signal
  });
};

export const getCreateBusinessHoursApiV1SupportBusinessHoursPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createBusinessHoursApiV1SupportBusinessHoursPost>
      >,
      TError,
      { data: BusinessHoursCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createBusinessHoursApiV1SupportBusinessHoursPost>
    >,
    TError,
    { data: BusinessHoursCreate },
    TContext
  > => {
    const mutationKey = ['createBusinessHoursApiV1SupportBusinessHoursPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createBusinessHoursApiV1SupportBusinessHoursPost>
      >,
      { data: BusinessHoursCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createBusinessHoursApiV1SupportBusinessHoursPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateBusinessHoursApiV1SupportBusinessHoursPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createBusinessHoursApiV1SupportBusinessHoursPost>>
  >;
export type CreateBusinessHoursApiV1SupportBusinessHoursPostMutationBody =
  BusinessHoursCreate;
export type CreateBusinessHoursApiV1SupportBusinessHoursPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Business Hours
 */
export const useCreateBusinessHoursApiV1SupportBusinessHoursPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createBusinessHoursApiV1SupportBusinessHoursPost>
      >,
      TError,
      { data: BusinessHoursCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBusinessHoursApiV1SupportBusinessHoursPost>>,
  TError,
  { data: BusinessHoursCreate },
  TContext
> => {
  const mutationOptions =
    getCreateBusinessHoursApiV1SupportBusinessHoursPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List KB categories.
 * @summary List Kb Categories
 */
export const listKbCategoriesApiV1SupportKbCategoriesGet = (
  params?: ListKbCategoriesApiV1SupportKbCategoriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/categories`,
    method: 'GET',
    params,
    signal
  });
};

export const getListKbCategoriesApiV1SupportKbCategoriesGetQueryKey = (
  params?: ListKbCategoriesApiV1SupportKbCategoriesGetParams
) => {
  return [
    `/api/v1/support/kb/categories`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListKbCategoriesApiV1SupportKbCategoriesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListKbCategoriesApiV1SupportKbCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListKbCategoriesApiV1SupportKbCategoriesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>
  > = ({ signal }) =>
    listKbCategoriesApiV1SupportKbCategoriesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListKbCategoriesApiV1SupportKbCategoriesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>
  >;
export type ListKbCategoriesApiV1SupportKbCategoriesGetQueryError =
  HTTPValidationError;

export function useListKbCategoriesApiV1SupportKbCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListKbCategoriesApiV1SupportKbCategoriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListKbCategoriesApiV1SupportKbCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListKbCategoriesApiV1SupportKbCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListKbCategoriesApiV1SupportKbCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListKbCategoriesApiV1SupportKbCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Kb Categories
 */

export function useListKbCategoriesApiV1SupportKbCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListKbCategoriesApiV1SupportKbCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbCategoriesApiV1SupportKbCategoriesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListKbCategoriesApiV1SupportKbCategoriesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a KB category.
 * @summary Create Kb Category
 */
export const createKbCategoryApiV1SupportKbCategoriesPost = (
  kBCategoryCreate: KBCategoryCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/categories`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: kBCategoryCreate,
    signal
  });
};

export const getCreateKbCategoryApiV1SupportKbCategoriesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKbCategoryApiV1SupportKbCategoriesPost>>,
    TError,
    { data: KBCategoryCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKbCategoryApiV1SupportKbCategoriesPost>>,
  TError,
  { data: KBCategoryCreate },
  TContext
> => {
  const mutationKey = ['createKbCategoryApiV1SupportKbCategoriesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKbCategoryApiV1SupportKbCategoriesPost>>,
    { data: KBCategoryCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createKbCategoryApiV1SupportKbCategoriesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKbCategoryApiV1SupportKbCategoriesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createKbCategoryApiV1SupportKbCategoriesPost>>
  >;
export type CreateKbCategoryApiV1SupportKbCategoriesPostMutationBody =
  KBCategoryCreate;
export type CreateKbCategoryApiV1SupportKbCategoriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Kb Category
 */
export const useCreateKbCategoryApiV1SupportKbCategoriesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKbCategoryApiV1SupportKbCategoriesPost>>,
      TError,
      { data: KBCategoryCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createKbCategoryApiV1SupportKbCategoriesPost>>,
  TError,
  { data: KBCategoryCreate },
  TContext
> => {
  const mutationOptions =
    getCreateKbCategoryApiV1SupportKbCategoriesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a KB category by ID.
 * @summary Get Kb Category
 */
export const getKbCategoryApiV1SupportKbCategoriesCategoryIdGet = (
  categoryId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/categories/${categoryId}`,
    method: 'GET',
    signal
  });
};

export const getGetKbCategoryApiV1SupportKbCategoriesCategoryIdGetQueryKey = (
  categoryId?: string
) => {
  return [`/api/v1/support/kb/categories/${categoryId}`] as const;
};

export const getGetKbCategoryApiV1SupportKbCategoriesCategoryIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
    >,
    TError = HTTPValidationError
  >(
    categoryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetKbCategoryApiV1SupportKbCategoriesCategoryIdGetQueryKey(categoryId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
      >
    > = ({ signal }) =>
      getKbCategoryApiV1SupportKbCategoriesCategoryIdGet(categoryId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!categoryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetKbCategoryApiV1SupportKbCategoriesCategoryIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
    >
  >;
export type GetKbCategoryApiV1SupportKbCategoriesCategoryIdGetQueryError =
  HTTPValidationError;

export function useGetKbCategoryApiV1SupportKbCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetKbCategoryApiV1SupportKbCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetKbCategoryApiV1SupportKbCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Kb Category
 */

export function useGetKbCategoryApiV1SupportKbCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbCategoryApiV1SupportKbCategoriesCategoryIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetKbCategoryApiV1SupportKbCategoriesCategoryIdGetQueryOptions(
      categoryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a KB category.
 * @summary Update Kb Category
 */
export const updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch = (
  categoryId: string,
  kBCategoryUpdate: KBCategoryUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/categories/${categoryId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: kBCategoryUpdate
  });
};

export const getUpdateKbCategoryApiV1SupportKbCategoriesCategoryIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch
        >
      >,
      TError,
      { categoryId: string; data: KBCategoryUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch>
    >,
    TError,
    { categoryId: string; data: KBCategoryUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch
        >
      >,
      { categoryId: string; data: KBCategoryUpdate }
    > = (props) => {
      const { categoryId, data } = props ?? {};

      return updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch(
        categoryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateKbCategoryApiV1SupportKbCategoriesCategoryIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch>
    >
  >;
export type UpdateKbCategoryApiV1SupportKbCategoriesCategoryIdPatchMutationBody =
  KBCategoryUpdate;
export type UpdateKbCategoryApiV1SupportKbCategoriesCategoryIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Kb Category
 */
export const useUpdateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch
        >
      >,
      TError,
      { categoryId: string; data: KBCategoryUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateKbCategoryApiV1SupportKbCategoriesCategoryIdPatch>
  >,
  TError,
  { categoryId: string; data: KBCategoryUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateKbCategoryApiV1SupportKbCategoriesCategoryIdPatchMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a KB category. Articles in this category will become uncategorized.
 * @summary Delete Kb Category
 */
export const deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete = (
  categoryId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/categories/${categoryId}`,
    method: 'DELETE'
  });
};

export const getDeleteKbCategoryApiV1SupportKbCategoriesCategoryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete
        >
      >,
      TError,
      { categoryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete
      >
    >,
    TError,
    { categoryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete
        >
      >,
      { categoryId: string }
    > = (props) => {
      const { categoryId } = props ?? {};

      return deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete(
        categoryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteKbCategoryApiV1SupportKbCategoriesCategoryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete
      >
    >
  >;

export type DeleteKbCategoryApiV1SupportKbCategoriesCategoryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Kb Category
 */
export const useDeleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete
        >
      >,
      TError,
      { categoryId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteKbCategoryApiV1SupportKbCategoriesCategoryIdDelete>
  >,
  TError,
  { categoryId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteKbCategoryApiV1SupportKbCategoriesCategoryIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List KB articles.
 * @summary List Kb Articles
 */
export const listKbArticlesApiV1SupportKbArticlesGet = (
  params?: ListKbArticlesApiV1SupportKbArticlesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles`,
    method: 'GET',
    params,
    signal
  });
};

export const getListKbArticlesApiV1SupportKbArticlesGetQueryKey = (
  params?: ListKbArticlesApiV1SupportKbArticlesGetParams
) => {
  return [`/api/v1/support/kb/articles`, ...(params ? [params] : [])] as const;
};

export const getListKbArticlesApiV1SupportKbArticlesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListKbArticlesApiV1SupportKbArticlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListKbArticlesApiV1SupportKbArticlesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>
  > = ({ signal }) => listKbArticlesApiV1SupportKbArticlesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListKbArticlesApiV1SupportKbArticlesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>
>;
export type ListKbArticlesApiV1SupportKbArticlesGetQueryError =
  HTTPValidationError;

export function useListKbArticlesApiV1SupportKbArticlesGet<
  TData = Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListKbArticlesApiV1SupportKbArticlesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
          TError,
          Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListKbArticlesApiV1SupportKbArticlesGet<
  TData = Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListKbArticlesApiV1SupportKbArticlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
          TError,
          Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListKbArticlesApiV1SupportKbArticlesGet<
  TData = Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListKbArticlesApiV1SupportKbArticlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Kb Articles
 */

export function useListKbArticlesApiV1SupportKbArticlesGet<
  TData = Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListKbArticlesApiV1SupportKbArticlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKbArticlesApiV1SupportKbArticlesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListKbArticlesApiV1SupportKbArticlesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a KB article.
 * @summary Create Kb Article
 */
export const createKbArticleApiV1SupportKbArticlesPost = (
  kBArticleCreate: KBArticleCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: kBArticleCreate,
    signal
  });
};

export const getCreateKbArticleApiV1SupportKbArticlesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKbArticleApiV1SupportKbArticlesPost>>,
    TError,
    { data: KBArticleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKbArticleApiV1SupportKbArticlesPost>>,
  TError,
  { data: KBArticleCreate },
  TContext
> => {
  const mutationKey = ['createKbArticleApiV1SupportKbArticlesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKbArticleApiV1SupportKbArticlesPost>>,
    { data: KBArticleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createKbArticleApiV1SupportKbArticlesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKbArticleApiV1SupportKbArticlesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createKbArticleApiV1SupportKbArticlesPost>>
  >;
export type CreateKbArticleApiV1SupportKbArticlesPostMutationBody =
  KBArticleCreate;
export type CreateKbArticleApiV1SupportKbArticlesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Kb Article
 */
export const useCreateKbArticleApiV1SupportKbArticlesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKbArticleApiV1SupportKbArticlesPost>>,
      TError,
      { data: KBArticleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createKbArticleApiV1SupportKbArticlesPost>>,
  TError,
  { data: KBArticleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateKbArticleApiV1SupportKbArticlesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a KB article.
 * @summary Get Kb Article
 */
export const getKbArticleApiV1SupportKbArticlesArticleIdGet = (
  articleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles/${articleId}`,
    method: 'GET',
    signal
  });
};

export const getGetKbArticleApiV1SupportKbArticlesArticleIdGetQueryKey = (
  articleId?: string
) => {
  return [`/api/v1/support/kb/articles/${articleId}`] as const;
};

export const getGetKbArticleApiV1SupportKbArticlesArticleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
  >,
  TError = HTTPValidationError
>(
  articleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetKbArticleApiV1SupportKbArticlesArticleIdGetQueryKey(articleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>>
  > = ({ signal }) =>
    getKbArticleApiV1SupportKbArticlesArticleIdGet(articleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!articleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetKbArticleApiV1SupportKbArticlesArticleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>>
  >;
export type GetKbArticleApiV1SupportKbArticlesArticleIdGetQueryError =
  HTTPValidationError;

export function useGetKbArticleApiV1SupportKbArticlesArticleIdGet<
  TData = Awaited<
    ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
  >,
  TError = HTTPValidationError
>(
  articleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetKbArticleApiV1SupportKbArticlesArticleIdGet<
  TData = Awaited<
    ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
  >,
  TError = HTTPValidationError
>(
  articleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetKbArticleApiV1SupportKbArticlesArticleIdGet<
  TData = Awaited<
    ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
  >,
  TError = HTTPValidationError
>(
  articleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Kb Article
 */

export function useGetKbArticleApiV1SupportKbArticlesArticleIdGet<
  TData = Awaited<
    ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
  >,
  TError = HTTPValidationError
>(
  articleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKbArticleApiV1SupportKbArticlesArticleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetKbArticleApiV1SupportKbArticlesArticleIdGetQueryOptions(
      articleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a KB article.
 * @summary Update Kb Article
 */
export const updateKbArticleApiV1SupportKbArticlesArticleIdPut = (
  articleId: string,
  kBArticleUpdate: KBArticleUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles/${articleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: kBArticleUpdate
  });
};

export const getUpdateKbArticleApiV1SupportKbArticlesArticleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateKbArticleApiV1SupportKbArticlesArticleIdPut>
      >,
      TError,
      { articleId: string; data: KBArticleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateKbArticleApiV1SupportKbArticlesArticleIdPut>
    >,
    TError,
    { articleId: string; data: KBArticleUpdate },
    TContext
  > => {
    const mutationKey = ['updateKbArticleApiV1SupportKbArticlesArticleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateKbArticleApiV1SupportKbArticlesArticleIdPut>
      >,
      { articleId: string; data: KBArticleUpdate }
    > = (props) => {
      const { articleId, data } = props ?? {};

      return updateKbArticleApiV1SupportKbArticlesArticleIdPut(articleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateKbArticleApiV1SupportKbArticlesArticleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateKbArticleApiV1SupportKbArticlesArticleIdPut>
    >
  >;
export type UpdateKbArticleApiV1SupportKbArticlesArticleIdPutMutationBody =
  KBArticleUpdate;
export type UpdateKbArticleApiV1SupportKbArticlesArticleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Kb Article
 */
export const useUpdateKbArticleApiV1SupportKbArticlesArticleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateKbArticleApiV1SupportKbArticlesArticleIdPut>
      >,
      TError,
      { articleId: string; data: KBArticleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateKbArticleApiV1SupportKbArticlesArticleIdPut>>,
  TError,
  { articleId: string; data: KBArticleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateKbArticleApiV1SupportKbArticlesArticleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a KB article.
 * @summary Delete Kb Article
 */
export const deleteKbArticleApiV1SupportKbArticlesArticleIdDelete = (
  articleId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles/${articleId}`,
    method: 'DELETE'
  });
};

export const getDeleteKbArticleApiV1SupportKbArticlesArticleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteKbArticleApiV1SupportKbArticlesArticleIdDelete>
      >,
      TError,
      { articleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteKbArticleApiV1SupportKbArticlesArticleIdDelete>
    >,
    TError,
    { articleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteKbArticleApiV1SupportKbArticlesArticleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteKbArticleApiV1SupportKbArticlesArticleIdDelete>
      >,
      { articleId: string }
    > = (props) => {
      const { articleId } = props ?? {};

      return deleteKbArticleApiV1SupportKbArticlesArticleIdDelete(articleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteKbArticleApiV1SupportKbArticlesArticleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteKbArticleApiV1SupportKbArticlesArticleIdDelete>
    >
  >;

export type DeleteKbArticleApiV1SupportKbArticlesArticleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Kb Article
 */
export const useDeleteKbArticleApiV1SupportKbArticlesArticleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteKbArticleApiV1SupportKbArticlesArticleIdDelete>
      >,
      TError,
      { articleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteKbArticleApiV1SupportKbArticlesArticleIdDelete>
  >,
  TError,
  { articleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteKbArticleApiV1SupportKbArticlesArticleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Publish a KB article.
 * @summary Publish Kb Article
 */
export const publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost = (
  articleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles/${articleId}/publish`,
    method: 'POST',
    signal
  });
};

export const getPublishKbArticleApiV1SupportKbArticlesArticleIdPublishPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost
        >
      >,
      TError,
      { articleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost
      >
    >,
    TError,
    { articleId: string },
    TContext
  > => {
    const mutationKey = [
      'publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost
        >
      >,
      { articleId: string }
    > = (props) => {
      const { articleId } = props ?? {};

      return publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost(
        articleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PublishKbArticleApiV1SupportKbArticlesArticleIdPublishPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost
      >
    >
  >;

export type PublishKbArticleApiV1SupportKbArticlesArticleIdPublishPostMutationError =
  HTTPValidationError;

/**
 * @summary Publish Kb Article
 */
export const usePublishKbArticleApiV1SupportKbArticlesArticleIdPublishPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost
        >
      >,
      TError,
      { articleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof publishKbArticleApiV1SupportKbArticlesArticleIdPublishPost
    >
  >,
  TError,
  { articleId: string },
  TContext
> => {
  const mutationOptions =
    getPublishKbArticleApiV1SupportKbArticlesArticleIdPublishPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Archive a KB article.

The sibling of ``/publish`` above. ``KBService.archive_article`` has existed
since the module was written; this route did not, so the Archive button on the
article detail page 404'd for the feature's whole life (WI 32c0c816).
 * @summary Archive Kb Article
 */
export const archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost = (
  articleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/kb/articles/${articleId}/archive`,
    method: 'POST',
    signal
  });
};

export const getArchiveKbArticleApiV1SupportKbArticlesArticleIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost
        >
      >,
      TError,
      { articleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost
      >
    >,
    TError,
    { articleId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost
        >
      >,
      { articleId: string }
    > = (props) => {
      const { articleId } = props ?? {};

      return archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost(
        articleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveKbArticleApiV1SupportKbArticlesArticleIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost
      >
    >
  >;

export type ArchiveKbArticleApiV1SupportKbArticlesArticleIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Kb Article
 */
export const useArchiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost
        >
      >,
      TError,
      { articleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof archiveKbArticleApiV1SupportKbArticlesArticleIdArchivePost
    >
  >,
  TError,
  { articleId: string },
  TContext
> => {
  const mutationOptions =
    getArchiveKbArticleApiV1SupportKbArticlesArticleIdArchivePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit feedback for a KB article.
 * @summary Submit Article Feedback
 */
export const submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost =
  (
    articleId: string,
    kBArticleFeedback: KBArticleFeedback,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/support/kb/articles/${articleId}/feedback`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: kBArticleFeedback,
      signal
    });
  };

export const getSubmitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost
        >
      >,
      TError,
      { articleId: string; data: KBArticleFeedback },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost
      >
    >,
    TError,
    { articleId: string; data: KBArticleFeedback },
    TContext
  > => {
    const mutationKey = [
      'submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost
        >
      >,
      { articleId: string; data: KBArticleFeedback }
    > = (props) => {
      const { articleId, data } = props ?? {};

      return submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost(
        articleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SubmitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost
      >
    >
  >;
export type SubmitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPostMutationBody =
  KBArticleFeedback;
export type SubmitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Article Feedback
 */
export const useSubmitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost
          >
        >,
        TError,
        { articleId: string; data: KBArticleFeedback },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof submitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPost
      >
    >,
    TError,
    { articleId: string; data: KBArticleFeedback },
    TContext
  > => {
    const mutationOptions =
      getSubmitArticleFeedbackApiV1SupportKbArticlesArticleIdFeedbackPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get current user's support settings.
 * @summary Get User Settings
 */
export const getUserSettingsApiV1SupportSettingsUserGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/settings/user`,
    method: 'GET',
    signal
  });
};

export const getGetUserSettingsApiV1SupportSettingsUserGetQueryKey = () => {
  return [`/api/v1/support/settings/user`] as const;
};

export const getGetUserSettingsApiV1SupportSettingsUserGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserSettingsApiV1SupportSettingsUserGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>
  > = ({ signal }) => getUserSettingsApiV1SupportSettingsUserGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserSettingsApiV1SupportSettingsUserGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>
>;
export type GetUserSettingsApiV1SupportSettingsUserGetQueryError = unknown;

export function useGetUserSettingsApiV1SupportSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
          >,
          TError,
          Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSettingsApiV1SupportSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
          >,
          TError,
          Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSettingsApiV1SupportSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Settings
 */

export function useGetUserSettingsApiV1SupportSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSettingsApiV1SupportSettingsUserGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserSettingsApiV1SupportSettingsUserGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current user's support settings.
 * @summary Update User Settings
 */
export const updateUserSettingsApiV1SupportSettingsUserPut = (
  updateUserSettingsApiV1SupportSettingsUserPutBody: UpdateUserSettingsApiV1SupportSettingsUserPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/settings/user`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUserSettingsApiV1SupportSettingsUserPutBody
  });
};

export const getUpdateUserSettingsApiV1SupportSettingsUserPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserSettingsApiV1SupportSettingsUserPut>>,
    TError,
    { data: UpdateUserSettingsApiV1SupportSettingsUserPutBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserSettingsApiV1SupportSettingsUserPut>>,
  TError,
  { data: UpdateUserSettingsApiV1SupportSettingsUserPutBody },
  TContext
> => {
  const mutationKey = ['updateUserSettingsApiV1SupportSettingsUserPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserSettingsApiV1SupportSettingsUserPut>>,
    { data: UpdateUserSettingsApiV1SupportSettingsUserPutBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateUserSettingsApiV1SupportSettingsUserPut(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserSettingsApiV1SupportSettingsUserPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateUserSettingsApiV1SupportSettingsUserPut>>
  >;
export type UpdateUserSettingsApiV1SupportSettingsUserPutMutationBody =
  UpdateUserSettingsApiV1SupportSettingsUserPutBody;
export type UpdateUserSettingsApiV1SupportSettingsUserPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Settings
 */
export const useUpdateUserSettingsApiV1SupportSettingsUserPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserSettingsApiV1SupportSettingsUserPut>>,
      TError,
      { data: UpdateUserSettingsApiV1SupportSettingsUserPutBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserSettingsApiV1SupportSettingsUserPut>>,
  TError,
  { data: UpdateUserSettingsApiV1SupportSettingsUserPutBody },
  TContext
> => {
  const mutationOptions =
    getUpdateUserSettingsApiV1SupportSettingsUserPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get effective settings with inheritance.
 * @summary Get Effective Settings
 */
export const getEffectiveSettingsApiV1SupportSettingsEffectiveGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/support/settings/effective`,
    method: 'GET',
    signal
  });
};

export const getGetEffectiveSettingsApiV1SupportSettingsEffectiveGetQueryKey =
  () => {
    return [`/api/v1/support/settings/effective`] as const;
  };

export const getGetEffectiveSettingsApiV1SupportSettingsEffectiveGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEffectiveSettingsApiV1SupportSettingsEffectiveGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
      >
    > = ({ signal }) =>
      getEffectiveSettingsApiV1SupportSettingsEffectiveGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEffectiveSettingsApiV1SupportSettingsEffectiveGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
    >
  >;
export type GetEffectiveSettingsApiV1SupportSettingsEffectiveGetQueryError =
  unknown;

export function useGetEffectiveSettingsApiV1SupportSettingsEffectiveGet<
  TData = Awaited<
    ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEffectiveSettingsApiV1SupportSettingsEffectiveGet<
  TData = Awaited<
    ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEffectiveSettingsApiV1SupportSettingsEffectiveGet<
  TData = Awaited<
    ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Effective Settings
 */

export function useGetEffectiveSettingsApiV1SupportSettingsEffectiveGet<
  TData = Awaited<
    ReturnType<typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEffectiveSettingsApiV1SupportSettingsEffectiveGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEffectiveSettingsApiV1SupportSettingsEffectiveGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
